import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Badge as Badge$1, Tooltip } from '@vds/core';
import styles from './badge.module.scss.js';

const Badge = (props) => {
    const { renderIcon, tooltip, children, surface: surfaceProp = 'lightPrimary', numberOfLines, showBorder = true, backgroundColor: backgroundColorProp = 'red', textColor } = props, rest = __rest(props, ["renderIcon", "tooltip", "children", "surface", "numberOfLines", "showBorder", "backgroundColor", "textColor"]);
    const surface = surfaceProp === null || surfaceProp === void 0 ? void 0 : surfaceProp.toLowerCase();
    const mappedSurface = String(surface).includes('dark') ? 'dark' : 'light';
    const backgroundColor = backgroundColorProp === null || backgroundColorProp === void 0 ? void 0 : backgroundColorProp.toLowerCase();
    const badgeWrapperStyles = [styles.badgeWrapper];
    if (backgroundColorProp === 'white' &&
        surfaceProp === 'lightPrimary' &&
        showBorder) {
        badgeWrapperStyles.push(styles.showBorder);
    }
    const contentColor = textColor ||
        `var(--vds-badges-text-color-on${backgroundColor}-on${surface})`;
    const tooltipSurface = () => {
        switch (backgroundColorProp) {
            case 'orange':
            case 'green':
            case 'blue':
            case 'grayHighContrast':
                if (mappedSurface === 'dark') {
                    return 'lightPrimary';
                }
                return 'darkPrimary';
            case 'grayLowContrast':
                if (mappedSurface === 'dark') {
                    return 'darkPrimary';
                }
                return 'lightPrimary';
            case 'yellow':
            case 'neonYellow':
            case 'white':
            case 'stone':
                return 'lightPrimary';
            case 'black':
            case 'red':
                return 'darkPrimary';
            default:
                if (mappedSurface === 'dark') {
                    return 'lightPrimary';
                }
                return 'darkPrimary';
        }
    };
    return (jsx("div", { className: badgeWrapperStyles.join(' '), children: jsx(Badge$1, Object.assign({ backgroundColor: backgroundColorProp }, rest, { surface: surfaceProp, children: jsxs("div", { className: styles.badgeContent, children: [renderIcon && (jsx("div", { className: styles.icon, children: renderIcon({
                            size: 'small',
                            surface: surfaceProp,
                            color: contentColor,
                        }) })), jsx("div", { className: styles.child, style: {
                            WebkitLineClamp: numberOfLines !== null && numberOfLines !== void 0 ? numberOfLines : 'none',
                            color: contentColor,
                        }, children: children }), tooltip && (jsx("div", { className: styles.tooltip, children: jsx(Tooltip, Object.assign({ size: "small", surface: tooltipSurface(), iconColor: contentColor }, tooltip)) }))] }) })) }));
};

export { Badge as default };
